import { Favorite16, FavoriteFilled16 } from '@carbon/icons-react';
import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

export interface LikeButtonProps {
  onClick?: () => void;
  icon?: ReactNode;
  isActive?: boolean;
  darkBg?: boolean;
  tabIndex?: number;
  classNames?: string;
}

const LikeButton: FC<LikeButtonProps> = (props: LikeButtonProps) => {
  const {
    onClick,
    isActive = false,
    darkBg = false,
    tabIndex,
    classNames,
  } = props;
  return (
    <button
      type="button"
      className={clsx(
        'inline-flex items-center p-[8px] rounded-circle text-red70 focus:ring-inset',
        darkBg && 'bg-white',
        !darkBg && 'bg-transparent',
        classNames
      )}
      tabIndex={tabIndex || 1}
      onClick={onClick}
    >
      {isActive ? (
        <FavoriteFilled16 className="h-[14px] w-[14px]" aria-hidden="true" />
      ) : (
        <Favorite16
          className="h-[14px] stroke-1 w-[14px] hover:stroke-2"
          aria-hidden="true"
        />
      )}
    </button>
  );
};

export default LikeButton;
